import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { useSiteSettings } from '../../hooks/useSiteSettings';

export const Testimonials = () => {
  const { getSetting } = useSiteSettings();

  // Get testimonials from settings
  const testimonials = [
    {
      id: 1,
      name: getSetting('testimonial_1_name', 'Sarah Johnson'),
      role: getSetting('testimonial_1_role', 'Verified Customer'),
      image: getSetting('testimonial_1_image', 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&q=80'),
      rating: 5,
      text: getSetting('testimonial_1_text', 'Absolutely love the natural products! My skin has never looked better.'),
      verified: getSetting('testimonial_1_verified', 'true') === 'true'
    },
    {
      id: 2,
      name: getSetting('testimonial_2_name', 'Michael Chen'),
      role: getSetting('testimonial_2_role', 'Verified Customer'),
      image: getSetting('testimonial_2_image', 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&q=80'),
      rating: 5,
      text: getSetting('testimonial_2_text', 'Great selection of products. Will definitely order again!'),
      verified: getSetting('testimonial_2_verified', 'true') === 'true'
    },
    {
      id: 3,
      name: getSetting('testimonial_3_name', 'Emily Rodriguez'),
      role: getSetting('testimonial_3_role', 'Verified Customer'),
      image: getSetting('testimonial_3_image', 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&q=80'),
      rating: 5,
      text: getSetting('testimonial_3_text', 'The baby products are so gentle and safe. Highly recommend!'),
      verified: getSetting('testimonial_3_verified', 'true') === 'true'
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-muted/30">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="font-serif text-4xl sm:text-5xl font-bold text-foreground mb-4">
            {getSetting('testimonials_title', 'What Our Customers Say')}
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {getSetting('testimonials_subtitle', 'Real reviews from real customers who love our natural products')}
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <Card className="h-full">
                <CardContent className="p-6">
                  <Quote className="w-10 h-10 text-primary/20 mb-4" />
                  
                  {/* Rating */}
                  <div className="flex items-center gap-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="w-4 h-4 fill-primary text-primary" />
                    ))}
                  </div>

                  {/* Review Text */}
                  <p className="text-muted-foreground leading-relaxed mb-6">
                    "{testimonial.text}"
                  </p>

                  {/* Reviewer */}
                  <div className="flex items-center gap-3">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="w-12 h-12 rounded-full object-cover"
                    />
                    <div>
                      <p className="font-semibold">{testimonial.name}</p>
                      <p className="text-sm text-muted-foreground">{testimonial.role}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};